import { render } from "./Tab.vue?vue&type=template&id=05fc7d1b&ts=true"
import script from "./Tab.vue?vue&type=script&lang=ts"
export * from "./Tab.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__